import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import { initAuthRefresh } from '@/lib/pocketbase';
import '@/styles/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Élément #root introuvable dans index.html');
}

void initAuthRefresh();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
